/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import DashboardBG from '../../assets/svg/DashboardBG.svg';
import { Footer } from '../Footer/Footer';
import { ToggleColorMode, NewSideBar } from '../index';
import { Box, Grid } from '@mui/material';

const style = {
  display: 'flex',
  height: '100%',
  padding: '0 0 0 20px',
  overflow: 'hidden',
  mb: 3,
};

const bg = {
  position: 'absolute',
  backgroundImage: `url(${DashboardBG})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  width: '100%',
  minHeight: '100%',
};

export const GridContainer = (props) => {
  return (
    <ToggleColorMode mode="dark">
      <div style={bg}>
        <Box sx={style}>
          <NewSideBar selectedPage={props.selectedPage} />
          <Box sx={{ display: 'flex', width: '100%', pt: 1, px: 2 }}>
            <Grid sx={{ width: '100%', margin: '0' }} container>
              {props.children}
            </Grid>
          </Box>
        </Box>
        <Footer />
      </div>
    </ToggleColorMode>
  );
};
